import useSWR from 'swr';
import { trpc } from '../config/trpc';

export type PublicBusSegment = Awaited<
  ReturnType<typeof trpc.publicTransport.getBusSegmentBySiteId.query>
>[number];

export function useSiteBusSegmentsData({ siteId }: { siteId?: string }) {
  const { data, mutate, isValidating, error } = useSWR<PublicBusSegment[]>(
    siteId
      ? {
          keyName: 'useSiteBusSegmentsData',
          siteId,
        }
      : null,
    async (params) => trpc.publicTransport.getBusSegmentBySiteId.query(params)
  );
  return {
    data,
    isValidating,
    error,
    updateBusSegment: async ({
      segmentId,
      name,
    }: {
      segmentId: string;
      name: string;
    }) => {
      if (!siteId) {
        throw new Error('Site ID is required');
      }
      await trpc.publicTransport.updateBusSegment.mutate({
        siteId,
        segmentId,
        name,
      });
      await mutate();
    },
    archiveBusSegment: async (segmentId: string) => {
      if (!siteId) {
        throw new Error('Site ID is required');
      }
      await trpc.publicTransport.archiveBusSegment.mutate({
        siteId,
        segmentId,
      });
      await mutate();
    },
    createBusRouteSegmentArea: async ({
      name,
      areaWkt,
      busRouteSegments,
    }: {
      name: string;
      areaWkt: string;
      busRouteSegments: {
        firstStopId: string;
        lastStopId: string;
        busRouteId: string;
      }[];
    }) => {
      if (!siteId) {
        throw new Error('Site ID is required');
      }
      await trpc.publicTransport.createBusRouteSegmentArea.mutate({
        siteId,
        description: '',
        name,
        areaWkt,
        busRouteSegments,
      });
      await mutate();
    },
  };
}
